import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Modal,
  Popconfirm,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
  Table,
  TimePicker,
  Divider,
  Row,
  Col,
  Avatar,
} from 'antd';
import {
  UploadOutlined,
  PictureOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import { genFormItemAtrribute } from 'libs/FormHelper';
import Validator from 'validatorjs';
import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import GoogleMapReact from 'google-map-react';

const Option = Select.Option;

const cardBodyStyle = { padding: 8, fontSize: 8 };
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

export default class CIBCInfo extends Component {
  formRef = React.createRef();
  state = {
    CIBCInfo: {
      id: null,
      name: '',
      iscibc: false,
      iscibc_name: '',
      address: '',
      users: [],
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    isImage: false,
    iscibc: false,
    pic: false,
  };

  componentDidMount() {
    AppHelper.updateConfig();
    //console.log('CIBCInfo',devCIBCInfo)
    this.fetchData();
    this.fillData();
    //this.fillData(devCIBCInfo)
  }

  fillData = (data = {}) => {
    //console.log('CIBCInfo',data.iscibc)
    this.setState({ CIBCInfo: data }, () => {
      //console.log('CIBCInfo',data)
    });
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料

    //if (!_.isBoolean(data.status)) data.status = data.status === 1
    if (_.get(data, 'users.length') > 0) {
      const userInfo = _.get(data, 'users')[0];
      //console.log('CIBCInfo-userInfo',userInfo,)
      data.user_name = _.get(userInfo, 'name');
      data.user_seniority = _.get(userInfo, 'seniority');
      if (!_.isNil(userInfo.open_at) && !_.isNil(userInfo.close_at))
        data.user_service_time = [
          moment(_.get(userInfo, 'open_at'), 'HH:mm'),
          moment(_.get(userInfo, 'close_at'), 'HH:mm'),
        ];
      data.user_licenses = _.get(userInfo, 'licenses');
      if (_.get(userInfo, 'image.length') > 0) {
        data.image = _.get(userInfo, 'image');
        this.setState({ pic: true });
      } else this.setState({ pic: false });
    }
    data.user_location = _.get(data, 'store_group_name');
    this.setState({ iscibc: data.iscibc });
    //console.log('CIBCInfo-data',data)
    this.formRef.current.setFieldsValue(data);
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/cibcs/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/cibc');
        return;
      }
      this.fillData(data);
    });
  };
  submitData = (Info = {}) => {
    var user_id = null;
    if (_.get(Info, 'user_service_time.0'))
      var open_at = _.get(Info, 'user_service_time.0').format('HH:mm');
    if (_.get(Info, 'user_service_time.1'))
      var close_at = _.get(Info, 'user_service_time.1').format('HH:mm');
    if (_.get(this, 'state.CIBCInfo.users.length') > 0)
      user_id = _.get(this, 'state.CIBCInfo.users')[0].id;

    //console.log('idididid',_.get(this, 'state.CIBCInfo.users')[0],user_id)
    const user = [
      {
        id: user_id,
        name: _.get(Info, 'user_name'),
        image: _.get(Info, 'image'),
        licenses: _.get(Info, 'user_licenses'),
        location: _.get(Info, 'user_location'),
        seniority: _.get(Info, 'user_seniority'),
        open_at: open_at,
        close_at: close_at,
      },
    ];
    Info.users = user;
    Info.iscibc = _.get(this, 'state.iscibc');
    delete Info.user_name;
    delete Info.image;
    delete Info.user_licenses;
    delete Info.user_location;
    delete Info.user_seniority;
    delete Info.user_service_time;

    //console.log('submitData',Info)
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    Info.user_id = current_user.ID;
    // 把Control元件轉換回上傳資料
    const id = _.get(this, 'props.match.params.id', '');

    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(API_HOST + `/api/mgt/v1/cibcs/${id}`, Info, (state, res) => {
      console.log(state, res);
      this.setState({ isSubmitData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        notification['error']({
          message: '更新失敗',
          description: reason,
        });

        return this.setState({ messages: data.messages || {} });
      }

      const { data: { id: new_id } = {} } = res;

      if (new_id != id) {
        message.success('建立成功');
        this.setState({ Info: data });

        return this.props.history.replace(`/cibc/view/${new_id}`);
      }

      message.success('更新成功');
      return this.props.history.replace(`/cibc`);
    });
  };

  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(API_HOST + `/api/mgt/v1/cibcs/${id}`, {}, (state, res) => {
      this.setState({ isDeleteUser: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      notification['success']({
        message: '成功！已將此分店移除保經據點',
      });

      return this.props.history.replace(`/cibc`);
    });
  };
  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };
  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors());
    //const categoryOptions = _.get(options, 'brand_categories', []).filter(categoryInfo => !_.isEmpty(categoryInfo.items) )
    // 登入使用者的權限
    const editorPermissions = _.get(this.props, 'auth.permissions', {});
    const fileList = [];
    const options = _.get(this, 'props.app.options', {});
    const CIBCInfo = _.get(this, 'state.CIBCInfo');
    //const uploadList = this.formRef.current && _.isArray(this.formRef.current.getFieldValue('uploadList')) ? this.formRef.current.getFieldValue('uploadList') : []
    //console.log('uploadList', uploadList)

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/category`}>保經據點管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>保經據點資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          保經據點資訊<span />
        </h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onKeyDown={(e) => {
                this.enterNotSubmit(e);
              }}
              // onValuesChange={(changedFields, allFields) => {
              //   console.log('onValuesChange:', changedFields, allFields)
              //   if (_.has(changedFields, 'latitude') || _.has(changedFields, 'longitude')) {
              //     this.reloadMaps()
              //   }
              // }}
              // onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
              // onFieldsChange={(changedFields, allFields) => {
              //     const storeInfo = _.reduce(allFields,(obj,item) => {
              //         _.set(obj, item.name.join('.'), item.value)
              //         return obj
              //       }, {})
              //       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
              //       return true
              //     }}
            >
              <Form.Item
                style={{ textAlign: 'right' }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ marginLeft: 8 }}
                  disabled={!this.state.iscibc}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
              </Form.Item>
              <div className='flexBox' style={{ paddingBottom: '10px' }}>
                <Form.Item {...genFormItemAtrribute('name', '服務分店')}>
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('store_group_name', '區域')}
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('iscibc', '保經據點', 'checked')}
                >
                  <Popconfirm
                    title={
                      this.state.iscibc
                        ? '請確認是否移除此保經據點分店？'
                        : '請確認是否要新增保經據點？'
                    }
                    okText='確認'
                    cancelText='取消'
                    onConfirm={() => {
                      if (this.state.iscibc)
                        this.setState({ pic: false, iscibc: false }, () => {
                          this.deleteUser();
                        });
                      else this.setState({ iscibc: true });
                    }}
                    onCancel={() => {
                      if (this.state.iscibc) this.setState({ iscibc: true });
                      else this.setState({ iscibc: false });
                    }}
                  >
                    <Button danger={this.state.iscibc}>
                      {this.state.iscibc ? '刪除據點' : '啟用'}
                    </Button>
                  </Popconfirm>
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  label='地址'
                  name='address'
                  rules={[{ required: true, message: 'Street is required' }]}
                >
                  <Input
                    style={{ width: '70%' }}
                    placeholder='輸入地址'
                    disabled={!this.state.iscibc}
                  />
                </Form.Item>
              </div>
              <Divider>服務人員資訊</Divider>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('image', ' ')}
                  valuePropName='fileList'
                  rules={[{ required: true, message: '請上傳服務人員照片' }]}
                  //style={{ textAlign: "center" }}
                  //extra="第一張圖片為封面"
                >
                  <WUpload
                    multiple={false}
                    listType='picture'
                    disabled={!this.state.iscibc}
                    onChange={(fileList) => {
                      if (fileList.length >= 1) {
                        this.setState({ pic: true });
                      } else {
                        this.setState({ pic: false });
                      }
                    }}
                  >
                    {_.get(this, 'state.pic') ? null : (
                      <Button disabled={!this.state.iscibc}>
                        <UploadOutlined />
                        上傳照片
                      </Button>
                    )}
                  </WUpload>
                </Form.Item>
                <Form.Item>
                  <Form.List name='image'>
                    {() => {
                      const url = _.get(this.getFieldValue('image'), '0.url');
                      return (
                        <Avatar
                          shape='square'
                          size={270}
                          style={{ height: 350, lineHeight: 270 }}
                          icon={<PictureOutlined />}
                          src={url}
                        />
                      );
                    }}
                  </Form.List>
                </Form.Item>
                {/* <div className='flexBox'>
                  <p>{`封面圖片上傳 ${ImageSize(this.getFieldValue('category_id'))}`}</p>
                </div> */}
              </div>
              <div style={{ width: '70%' }}>
                <div className='flexBox'>
                  <Form.Item
                    {...genFormItemAtrribute('user_name', '姓名')}
                    rules={[{ required: true, message: '請輸入服務人員姓名' }]}
                  >
                    <Input disabled={!this.state.iscibc} />
                  </Form.Item>
                </div>
                <div className='flexBox'>
                  <Form.Item
                    {...genFormItemAtrribute('user_seniority', '服務年資')}
                    rules={[{ required: true, message: '請輸入服務人員年資' }]}
                  >
                    <Input disabled={!this.state.iscibc} />
                  </Form.Item>
                </div>
                <div className='flexBox'>
                  <Form.Item
                    {...genFormItemAtrribute('user_location', '服務據點')}
                    rules={[{ required: true, message: '請選擇服務據點' }]}
                  >
                    <Select disabled>
                      {_.map(_.get(options, 'store_groups', []), (item) => (
                        <Option key={item.id} value={item.name}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className='flexBox'>
                  <Form.Item
                    {...genFormItemAtrribute('user_service_time', '駐點時間')}
                    rules={[{ required: true, message: '請輸入駐點時間' }]}
                  >
                    <TimePicker.RangePicker
                      disabled={!this.state.iscibc}
                      format='HH:mm'
                    />
                  </Form.Item>
                </div>
                <div className='flexBox'>
                  <Form.Item
                    {...genFormItemAtrribute('user_licenses', '持有證照')}
                  >
                    <Input.TextArea disabled={!this.state.iscibc} rows={5} />
                  </Form.Item>
                </div>
              </div>
              {/* 
              <div className='flexBox'>
                <FormItem label="最後更新">
                  <span>
                    {storeInfo.modified_date && storeInfo.modified_date.substring(0, 10)}
                    <i>{storeInfo.modified_date ? storeInfo.modified_date.substring(11) : '---'}{storeInfo.modified_user_name && ` by ${storeInfo.modified_user_name}`}</i>
                  </span>
                </FormItem>
              </div> 
              */}
            </Form>
          </div>
        </Skeleton>
      </Layout>
    );
  }
}

const devCIBCInfo = {
  id: 81,
  name: '新仁店',
  iscibc: true,
  iscibc_name: '是',
  address: '717 台南市仁德區仁愛里大同路三段755號',
  users: [
    {
      id: 1,
      name: '王曉明',
      image: [
        {
          // 有ID代表之前已經上傳過了
          id: 1,
          path: 'uploads/6180ef9fd195448b2edcd3a18d840bd4.jpg',
          url:
            'https://testwww.uni-prosperity.com.tw/console/uploads/6180ef9fd195448b2edcd3a18d840bd4.jpg',
        },
      ],
      location: '',
      seniority: 10,
      open_at: '09:00',
      close_at: '18:00',
      licenses: '壽險,...',
    },
  ],
  created_at: '2019-12-06 11:41:10',
  updated_at: '2020-05-15 16:47:02',
};



// WEBPACK FOOTER //
// ./src/views/CIBC/CIBCInfo.js